"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require("babel-runtime/core-js/object/entries");

var _entries2 = _interopRequireDefault(_entries);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends6 = require("babel-runtime/helpers/extends");

var _extends7 = _interopRequireDefault(_extends6);

var _quixelBusinessCountries = require("@quixeltools/quixel-business-countries");

var _quixelBusinessCountries2 = _interopRequireDefault(_quixelBusinessCountries);

var _hyperwalletValidCountries = require("./hyperwallet-valid-countries");

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _TextInput = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextInput");

var _TextInput2 = _interopRequireDefault(_TextInput);

var _Columns = require("@quixeltools/quixel-ui-library/dist/components/common/website/Columns");

var _Columns2 = _interopRequireDefault(_Columns);

var _Form = require("@quixeltools/quixel-ui-library/dist/components/common/website/Form");

var _Form2 = _interopRequireDefault(_Form);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _ramda = require("ramda");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _underscore = require("underscore");

var _Popup = require("../../components/Popup/Popup");

var _Popup2 = _interopRequireDefault(_Popup);

var _user = require("../../redux/modules/user");

var _helpersStylesIcons = require("./helpers-styles-icons");

var _TextSelectField = require("./TextSelectField");

var _TextSelectField2 = _interopRequireDefault(_TextSelectField);

var _validator = require("./validator");

var _validator2 = _interopRequireDefault(_validator);

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getInitialFieldState = function getInitialFieldState() {
  var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return { value: defaultValue, error: null };
};
var xformedCountries = _hyperwalletValidCountries.HYPERWALLET_VALID_COUNTRIES.map(function (c1) {
  return _quixelBusinessCountries2.default.find(function (c2) {
    return c2.code === c1.code;
  });
}).filter(function (i) {
  return i;
}).sort(function (a, b) {
  return a.name.localeCompare(b.name);
}).map(function (c) {
  return { label: c.name, value: c.code };
});
var xformedCountriesMap = xformedCountries.reduce(function (a, c) {
  return (0, _extends7.default)({}, a, (0, _defineProperty3.default)({}, c.value, c.label));
}, {});

var HyperWalletFormPopup = function (_React$Component) {
  (0, _inherits3.default)(HyperWalletFormPopup, _React$Component);

  function HyperWalletFormPopup(props) {
    (0, _classCallCheck3.default)(this, HyperWalletFormPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HyperWalletFormPopup.__proto__ || (0, _getPrototypeOf2.default)(HyperWalletFormPopup)).call(this, props));

    _this.handleContinue = function () {
      if (_this.validateForm(true)) {
        (_this.props.isRetrying ? _this.props.retryForCashRefund : _this.props.registerUserForCashRefund)(Object.fromEntries((0, _entries2.default)({
          country: _this.state.form.country.value,
          postalCode: _this.state.form.postalCode.value,
          stateProvince: _this.state.form.stateProvince.value,
          city: _this.state.form.city.value,
          addressLine1: _this.state.form.addressLine1.value,
          addressLine2: _this.state.form.addressLine2.value,
          phoneNumber: _this.state.form.phoneNumber.value,
          dateOfBirth: _this.state.form.dateOfBirth.value
        }).filter(function (_ref) {
          var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
              k = _ref2[0],
              v = _ref2[1];

          return !!v;
        }))).then(function (response) {
          _this.setState((0, _extends7.default)({}, response));
          if (response.success) _this.props.fetchPointsRefundEligibility();

          if (response.error && response.error.fieldName && response.error.isError) {
            _this.setState(function (state) {
              return {
                form: (0, _extends7.default)({}, state.form, (0, _defineProperty3.default)({}, response.error.fieldName, (0, _extends7.default)({}, state.form[response.error.fieldName], {
                  error: String(response.error.message)
                })))
              };
            });
          }
        });
      }
    };

    _this.validateForm = function () {
      var setErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var errors = (0, _keys2.default)(_this.state.form).reduce(function (acc, key) {
        var error = _this.validateField(key, _this.state.form[key].value);
        if (error) acc[key] = error;
        return acc;
      }, {});

      if (setErrors) {
        (0, _keys2.default)(errors).forEach(function (key) {
          _this.setState(function (state) {
            return {
              form: (0, _extends7.default)({}, state.form, (0, _defineProperty3.default)({}, key, (0, _extends7.default)({}, state.form[key], { error: errors[key] })))
            };
          });
        });
      }

      var isValid = (0, _keys2.default)(errors).length === 0;

      _this.setState({ isFormValid: isValid });

      return isValid;
    };

    _this.validateField = function (name, value) {
      var error = null;

      switch (name) {
        case "firstName":
        case "lastName":
          error = _validator2.default.string(value).isRequired().maxLength(50).getError();
          break;

        case "email":
          error = _validator2.default.string(value).isRequired().maxLength(100).isEmail().getError();
          break;

        case "phoneNumber":
          error = _validator2.default.string(value).isRequired().maxLength(30).getError();
          break;

        case "addressLine1":
          error = _validator2.default.string(value).isRequired().maxLength(255).getError();
          break;

        case "addressLine2":
          error = _validator2.default.string(value).maxLength(255).getError();
          break;

        case "country":
        case "stateProvince":
        case "city":
          error = _validator2.default.string(value).isRequired().getError();
          break;

        case "postalCode":
          error = _validator2.default.number(value).isRequired().maxLength(15).getError();
          break;

        case "dateOfBirth":
          error = _validator2.default.date(new Date(value)).isRequired().getError();
          break;

        default:
          break;
      }

      return error;
    };

    _this.handleFieldChange = function (name) {
      return function (event, _value) {
        var value = null;
        if (event && event.target && event.target.value !== undefined) {
          value = event.target.value;
        } else if (_value !== undefined) {
          value = _value;
        }

        if (value !== null && !(0, _ramda.equals)(value, _this.state.form[name].value)) {
          _this.setState(function (state) {
            return {
              form: (0, _extends7.default)({}, state.form, (0, _defineProperty3.default)({}, name, (0, _extends7.default)({}, state.form[name], {
                value: value,
                error: _this.validateField(name, value)
              })))
            };
          }, function () {
            _this.afterFieldChange(name, value);
            _this.validateForm();
          });
        }
      };
    };

    _this.afterFieldChange = (0, _underscore.debounce)(function (name, value) {
      var form = _this.state.form;
      switch (name) {
        case "country":
          if (value) {
            _this.handleFieldChange("stateProvince")(undefined, "");
            _this.handleFieldChange("city")(undefined, "");
            _this.setState({
              states: [{ label: "Loading...", value: null, disabled: true }],
              cities: [],
              isLoadingStates: true
            });
            (0, _helpersStylesIcons.fetchStatesAndCities)({ country: xformedCountriesMap[value] }).then(function (response) {
              _this.setState((0, _extends7.default)({}, response, { isLoadingStates: false }));
            });
          }
          break;

        case "stateProvince":
          if (value) {
            var stateProvince = _this.state.states.find(function (state) {
              return state.value === value;
            });
            if (stateProvince) {
              _this.handleFieldChange("city")(undefined, "");
              _this.setState({
                cities: [{ label: "Loading...", value: null, disabled: true }],
                isLoadingCities: true
              });
              (0, _helpersStylesIcons.fetchStatesAndCities)({
                country: xformedCountriesMap[form.country.value],
                state: stateProvince.label
              }).then(function (response) {
                _this.setState((0, _extends7.default)({}, response, { isLoadingCities: false }));
              });
            }
          }
          break;

        default:
          break;
      }
    }, 250);

    _this.state = {
      error: null,
      success: false,
      states: [],
      cities: [],
      isFormValid: true,
      isLoadingStates: false,
      isLoadingCities: false,
      form: {
        firstName: getInitialFieldState(),
        lastName: getInitialFieldState(),
        email: getInitialFieldState(),
        phoneNumber: getInitialFieldState(),
        addressLine1: getInitialFieldState(),
        addressLine2: getInitialFieldState(),
        country: getInitialFieldState(),
        postalCode: getInitialFieldState(),
        stateProvince: getInitialFieldState(),
        city: getInitialFieldState(),
        dateOfBirth: getInitialFieldState()
      }
    };
    return _this;
  }

  (0, _createClass3.default)(HyperWalletFormPopup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.props.getUserInfoForCashRefund().then(function (response) {
        if (response) {
          (0, _keys2.default)(response).forEach(function (key) {
            if (response[key]) {
              _this2.handleFieldChange(key)(undefined, response[key]);
            }
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
          _classNames;

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          {
            className: (0, _helpersStylesIcons.boxStyles)({
              width: this.state.success ? "480px" : "800px",
              "& > section": { width: "100%" }
            }) },
          _react2.default.createElement(
            _Popup2.default,
            null,
            _react2.default.createElement(
              _Popup2.default.Header,
              null,
              _react2.default.createElement(
                "div",
                {
                  className: (0, _helpersStylesIcons.boxStyles)({
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }) },
                _react2.default.createElement(
                  "span",
                  null,
                  "Get a cash refund"
                ),
                _react2.default.createElement(
                  "span",
                  { onClick: function onClick() {
                      return _this3.props.onCloseYes();
                    } },
                  _react2.default.createElement(_helpersStylesIcons.CloseIconSvg, null)
                )
              )
            ),
            _react2.default.createElement(
              _Popup2.default.Content,
              null,
              !this.state.success && _react2.default.createElement(
                "h4",
                {
                  className: (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, _helpersStylesIcons.title, true), (0, _defineProperty3.default)(_classNames, (0, _helpersStylesIcons.textStyles)({ color: "white" }), true), _classNames)) },
                "Verify your information"
              ),
              this.state.success ? _react2.default.createElement(
                "p",
                null,
                "Your information has been sent to Hyperwallet. They will email you soon about next steps to complete your refund request."
              ) : _react2.default.createElement(
                "p",
                null,
                "To begin the refund process, please complete and verify the information below. We will send this information to Hyperwallet, where you will be able to complete your refund request. Learn more about how HyperWallet handles your information in their",
                " ",
                _react2.default.createElement(
                  "a",
                  {
                    className: _helpersStylesIcons.anchorStyles,
                    href: "https://www.hyperwallet.com/privacy-policy/",
                    target: "_blank" },
                  "Privacy Policy"
                ),
                "."
              ),
              !this.state.success && _react2.default.createElement(
                "div",
                { className: (0, _helpersStylesIcons.boxStyles)({ marginTop: "32px" }) },
                _react2.default.createElement(
                  _Form2.default,
                  { id: "hyper-wallet-form" },
                  _react2.default.createElement(
                    "div",
                    {
                      className: (0, _helpersStylesIcons.boxStyles)({
                        display: "flex",
                        flexDirection: "column",
                        gap: "28px"
                      }) },
                    _react2.default.createElement(
                      _Columns2.default,
                      { n: 2, gutter: 4 },
                      _react2.default.createElement(_TextInput2.default, {
                        errorBelow: true,
                        disabled: true,
                        label: "First Name",
                        className: _helpersStylesIcons.textFieldStyles,
                        value: this.state.form.firstName.value,
                        error: this.state.form.firstName.error,
                        onChange: this.handleFieldChange("firstName")
                      }),
                      _react2.default.createElement(_TextInput2.default, {
                        errorBelow: true,
                        disabled: true,
                        label: "Last Name",
                        className: _helpersStylesIcons.textFieldStyles,
                        value: this.state.form.lastName.value,
                        error: this.state.form.lastName.error,
                        onChange: this.handleFieldChange("lastName")
                      })
                    ),
                    _react2.default.createElement(
                      _Columns2.default,
                      { n: 2, gutter: 4 },
                      _react2.default.createElement(_TextInput2.default, {
                        errorBelow: true,
                        disabled: true,
                        label: "Email",
                        className: _helpersStylesIcons.textFieldStyles,
                        value: this.state.form.email.value,
                        error: this.state.form.email.error,
                        onChange: this.handleFieldChange("email")
                      }),
                      _react2.default.createElement(_TextInput2.default, {
                        errorBelow: true,
                        label: "Phone Number",
                        className: _helpersStylesIcons.textFieldStyles,
                        value: this.state.form.phoneNumber.value,
                        error: this.state.form.phoneNumber.error,
                        onChange: this.handleFieldChange("phoneNumber")
                      })
                    ),
                    _react2.default.createElement(
                      _Columns2.default,
                      { n: 2, gutter: 4 },
                      _react2.default.createElement(_TextInput2.default, {
                        errorBelow: true,
                        label: "Address Line",
                        className: _helpersStylesIcons.textFieldStyles,
                        value: this.state.form.addressLine1.value,
                        error: this.state.form.addressLine1.error,
                        onChange: this.handleFieldChange("addressLine1")
                      }),
                      _react2.default.createElement(_TextInput2.default, {
                        errorBelow: true,
                        label: "Address Line 2 (Optional)",
                        className: _helpersStylesIcons.textFieldStyles,
                        value: this.state.form.addressLine2.value,
                        error: this.state.form.addressLine2.error,
                        onChange: this.handleFieldChange("addressLine2")
                      })
                    ),
                    _react2.default.createElement(
                      _Columns2.default,
                      { n: 2, gutter: 4 },
                      _react2.default.createElement(_TextSelectField2.default, {
                        label: "Country",
                        value: this.state.form.country.value,
                        error: this.state.form.country.error,
                        onChange: this.handleFieldChange("country"),
                        options: xformedCountries
                      }),
                      _react2.default.createElement(_TextInput2.default, {
                        errorBelow: true,
                        label: "Postal Code",
                        className: _helpersStylesIcons.textFieldStyles,
                        value: this.state.form.postalCode.value,
                        error: this.state.form.postalCode.error,
                        onChange: this.handleFieldChange("postalCode")
                      })
                    ),
                    _react2.default.createElement(
                      _Columns2.default,
                      { n: 2, gutter: 4 },
                      _react2.default.createElement(_TextSelectField2.default, {
                        allowUnlisted: true,
                        maxHeight: 160,
                        label: "State / Province / Region",
                        isLoading: this.state.isLoadingStates,
                        value: this.state.form.stateProvince.value,
                        error: this.state.form.stateProvince.error,
                        onChange: this.handleFieldChange("stateProvince"),
                        options: this.state.states
                      }),
                      _react2.default.createElement(_TextSelectField2.default, {
                        allowUnlisted: true,
                        maxHeight: 160,
                        label: "City",
                        isLoading: this.state.isLoadingCities,
                        value: this.state.form.city.value,
                        error: this.state.form.city.error,
                        onChange: this.handleFieldChange("city"),
                        options: this.state.cities
                      })
                    ),
                    _react2.default.createElement(
                      _Columns2.default,
                      { n: 2, gutter: 4 },
                      _react2.default.createElement(_TextInput2.default, {
                        errorBelow: true,
                        type: "date",
                        label: "Birthdate",
                        className: _helpersStylesIcons.textFieldStyles,
                        value: this.state.form.dateOfBirth.value,
                        error: this.state.form.dateOfBirth.error,
                        onChange: this.handleFieldChange("dateOfBirth")
                      })
                    )
                  )
                )
              ),
              this.state.error && _react2.default.createElement(
                "div",
                { className: (0, _helpersStylesIcons.boxStyles)({ display: "flex", gap: "16px", marginTop: "24px" }) },
                _react2.default.createElement(
                  "span",
                  {
                    className: (0, _helpersStylesIcons.boxStyles)({ marginTop: "4px", "& svg > path": { fill: "orange" } }) },
                  _react2.default.createElement(_helpersStylesIcons.ErrorIconSvg, null)
                ),
                _react2.default.createElement(
                  "span",
                  null,
                  "Something went wrong while registering you for refund through Hyper Wallet. Please check your inputs and try again after some time. If the problem persists, contact",
                  " ",
                  _react2.default.createElement(
                    "a",
                    { href: _config2.default.forumBaseUrl, className: _helpersStylesIcons.anchorStyles, target: "_blank" },
                    "our support team"
                  ),
                  "."
                )
              )
            ),
            !this.state.success && _react2.default.createElement(
              _Popup2.default.Footer,
              null,
              _react2.default.createElement(
                "div",
                {
                  className: (0, _helpersStylesIcons.boxStyles)({
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                    gap: "12px"
                  }) },
                _react2.default.createElement(_Button2.default, {
                  small: true,
                  mode: "transparentWithGrayBorder",
                  label: "Cancel",
                  onClick: function onClick() {
                    return _this3.props.onCloseYes();
                  },
                  className: _helpersStylesIcons.buttonStylesGhost
                }),
                _react2.default.createElement(_Button2.default, {
                  small: true,
                  mode: "secondary",
                  label: "Continue",
                  disabled: !this.state.isFormValid,
                  onClick: this.handleContinue,
                  className: _helpersStylesIcons.buttonStylesPrimary
                })
              )
            )
          )
        )
      );
    }
  }]);
  return HyperWalletFormPopup;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)(null, {
  getUserInfoForCashRefund: _user.getUserInfoForCashRefund,
  registerUserForCashRefund: _user.registerUserForCashRefund,
  fetchPointsRefundEligibility: _user.fetchPointsRefundEligibility,
  retryForCashRefund: _user.retryForCashRefund
})(HyperWalletFormPopup);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/ConvertPoints/HyperWalletFormPopup.jsx
// module id = 1268
// module chunks = 0